// Code for redirection according to primary language
const handleLanguageRedirection = () => {
  const root = Shopify.routes.root;

  // Function to attach the redirection event listener
  const redirectionClick = (selector) => {
    const redirectElements = document.querySelectorAll(selector); // Get all elements that match the selector

    redirectElements.forEach((redirectElement) => {
      console.log("Attaching event listener to:", redirectElement);

      redirectElement.addEventListener("click", (e) => {
        e.preventDefault(); // Prevent default navigation behavior

        // Find the closest anchor tag and get the href attribute
        const anchor = e.target.closest("a");
        if (anchor && anchor.getAttribute("href")) {
          const targetPath = anchor.getAttribute("href"); // Safely get href
          const redirectUrl = root + targetPath; // Construct the full redirect URL

          console.log("Redirecting to:", redirectUrl);
          window.location.assign(redirectUrl); // Perform the redirection
        } else {
          console.log("No valid href found for the clicked element");
        }
      });
    });
  };

  // Check if the current language is not 'en-it'
  if (root != "/") {
    // Attach the event listener to relevant elements
    redirectionClick(".hs1-logo-section");
    redirectionClick(".--account");
    redirectionClick(".new-return-to-store");
    redirectionClick(".have-an-account a");
    redirectionClick(".btn-wrapper a");
    redirectionClick(".forgot--btn");
    redirectionClick(".--cancel-button");
    // redirectionClick(".lq-product a");
  } else {
    console.log("Language is en-it, no redirection needed.");
  }
};

document.addEventListener("DOMContentLoaded", () => {
  console.log("Document is fully loaded and parsed!");

  // Call your function here after the DOM is ready
  handleLanguageRedirection();
});





